import { Commit } from 'vuex';
import { PreventifState } from './state';

export interface PreventifActionType {
    commit: Commit;
    state: PreventifState;
}

export enum PreventifActions {
    GET_PREVENTIF = 'GET_PREVENTIF',
    GET_XLS = 'GET_XLS',
    NEXT = 'NEXT_PREVENTIF',
    PREV = 'PREV_PREVENTIF',
    SET_IS_UNIQUE_SITE='SET_IS_UNIQUE_SITE'
}


